import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { ChevronDown } from 'lucide-react'
import { assets } from '../../config/assets'
import NewsletterSignup from '../NewsletterSignup'

function FaqItem({ question, answer, isOpen, onClick }) {
  return (
    <div className="border-b border-brand-blue/10 last:border-0">
      <button
        type="button"
        onClick={onClick}
        className="w-full flex items-center justify-between gap-4 py-4 text-left group"
      >
        <span className="font-bold text-brand-blue text-base md:text-lg">{question}</span>
        <ChevronDown
          size={24}
          className={`shrink-0 text-brand-orange transition-transform ${
            isOpen ? 'rotate-180' : ''
          }`}
        />
      </button>
      <div
        className={`overflow-hidden transition-all ${
          isOpen ? 'max-h-96 opacity-100 pb-4' : 'max-h-0 opacity-0'
        }`}
      >
        <p className="text-brand-blue/80 text-sm md:text-base leading-relaxed">{answer}</p>
      </div>
    </div>
  )
}

export default function FaqSection() {
  const { t } = useTranslation()
  const [openIndex, setOpenIndex] = useState(null)

  const faqKeys = [
    'whatBooks',
    'whatGenres',
    'individualOnly',
    'howChosen',
    'canPick',
    'anyBook',
    'duplicateBook',
    'dontLikeBook',
    'pickup',
    'whenDelivered',
    'notInPanel',
    'notOnTime',
  ]

  const toggle = (index) => {
    setOpenIndex(openIndex === index ? null : index)
  }

  return (
    <div className="max-w-6xl mx-auto w-full px-4">
      <div className="bg-brand-cream/95 rounded-[2rem] md:rounded-[3rem] p-6 md:p-12 lg:p-16 shadow-2xl space-y-8 md:space-y-12">
        {/* Heading */}
        <h2 className="font-climate text-brand-blue text-3xl md:text-5xl lg:text-6xl text-center leading-tight">
          {t('home.faq.title')}
        </h2>

        <p className="text-brand-blue/90 text-base md:text-lg leading-relaxed text-center max-w-4xl mx-auto">
          {t('home.faq.intro')}
        </p>

        {/* Social + newsletter */}
        <div className="flex flex-col md:flex-row items-center justify-center gap-4 md:gap-8">
          <a
            href="https://www.facebook.com/p/Abonamenty-Literackie-61592373429523/"
            target="_blank"
            rel="noopener noreferrer"
            className="text-brand-blue hover:text-brand-orange transition font-bold"
          >
            Facebook
          </a>
          <a
            href="https://www.instagram.com/abonamenty_literackie/"
            target="_blank"
            rel="noopener noreferrer"
            className="text-brand-blue hover:text-brand-orange transition font-bold"
          >
            Instagram
          </a>
        </div>

        <NewsletterSignup />

        {/* FAQ accordion */}
        <div className="space-y-4">
          <img
            src={assets.aboutUs.faqHeader}
            alt={t('home.faq.accordionTitle')}
            className="w-full h-auto rounded-[1.5rem]"
          />

          <div className="bg-white/70 rounded-[1.5rem] p-4 md:p-6">
            {faqKeys.map((key, index) => (
              <FaqItem
                key={key}
                question={t(`home.faq.items.${key}.question`)}
                answer={t(`home.faq.items.${key}.answer`)}
                isOpen={openIndex === index}
                onClick={() => toggle(index)}
              />
            ))}
          </div>
        </div>

        {/* Contact frame */}
        <img
          src={assets.aboutUs.contactFrame}
          alt={t('home.faq.contactAlt')}
          className="w-full h-auto rounded-[1.5rem]"
        />
      </div>
    </div>
  )
}
